import { CONVERSION_STATUS, CONVERSION_TYPE } from 'modules/tracking/config';
import { CONVERSION_LOCATION, CROSS_SITE_BUTTON_TYPE } from './conversionFlowConstants';

export const DEFAULT_NEW_EVENT_STRUCTURE = {
    status: CONVERSION_STATUS.ACTIVE,
    type: CONVERSION_TYPE.EVENT_BASED,
    category: '',
    includeInTotalConversions: false,
    eventName: '',
    urlEvent: '',
    conversionName: '',
    href: '',
    trackedElements: [],
    locationScope: CONVERSION_LOCATION.SPECIFIC_PAGE,
    crossSiteButtonType: CROSS_SITE_BUTTON_TYPE.COMBINE_SAME_TEXT_BUTTONS,
};
